import { combineReducers } from "redux";
import reduceReducers from "reduce-reducers";
import altAssets from "./alt-assets/reducer";
import app from "./app/reducer";
import appSettings from "./app-settings/reducer";
import assetAuditors from "./asset-auditors/reducer";
import auditAssets from "./audit-assets/reducer";
import auditAssignments from "./audit-assignments/reducer";
import auditCompletion from "./audit-completion/reducer";
import auditLocations from "./audit-locations/reducer";
import audits from "./audits/reducer";
import auditUpload from "./audit-upload/reducer";
import appSupport from "./app-support/reducer";
import auth from "./auth/reducer";
import geoLocation from "./geo-location/reducer";
import organisation from "./organisation/reducer";
import toast from "./toast/reducer";
import typesList from "./types-list/reducer";
import search from "./search/reducer";
import assetDetails from "./asset-details/reducer";
import debugState from "./debug-state/reducer";

/**
 * Root Reducer
 */
// Updating previously saved redux store from IndexedDB
const injectLoadedReduxState = (state, action) => {
    switch (action.type) {
        case "UPDATE_REDUX_TREE": {
            const { reduxState } = action.payload;
            let stateToMerge;

            if (reduxState) {
                reduxState["app"] = {
                    ...state.app,
                    reduxStateLoaded: true,
                };
                stateToMerge = reduxState;
            } else {
                stateToMerge = {
                    app: { ...state.app, reduxStateLoaded: true },
                };
            }

            return { ...state, ...stateToMerge };
        }
        default: {
            return state;
        }
    }
};
export default reduceReducers(
    combineReducers({
        altAssets,
        app,
        appSettings,
        assetAuditors,
        auditAssets,
        auditAssignments,
        auditCompletion,
        auditLocations,
        audits,
        auditUpload,
        appSupport,
        auth,
        geoLocation,
        organisation,
        toast,
        typesList,
        search,
        assetDetails,
        debugState,
    }),
    injectLoadedReduxState
);
